import { useSearchParams } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import iconUrl from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";


const customIcon = new L.Icon({
  iconUrl,
  shadowUrl: iconShadow,
  iconSize: [25, 41], 
  iconAnchor: [12, 41], 
  popupAnchor: [1, -34], 
  shadowSize: [41, 41], 
});

export default function Mapa() {
  const [searchParams] = useSearchParams();
  const lat = parseFloat(searchParams.get("lat"));
  const lng = parseFloat(searchParams.get("lng"));
  const mag = searchParams.get("mag");
  const region = searchParams.get("region");

  return (
    <div style={{ height: "100vh", width: "100%" }}>
      <MapContainer center={[lat, lng]} zoom={6} style={{ height: "100%", width: "100%" }}>
        <TileLayer
          attribution='&copy; OpenStreetMap contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={[lat, lng]} icon={customIcon}>
          <Popup>
            <strong>Región:</strong> {region} <br />
            <strong>Magnitud:</strong> {mag} <br />
            <strong>Lat:</strong> {lat} <br />
            <strong>Lng:</strong> {lng}
          </Popup>
        </Marker>
      </MapContainer>
    </div>
  );
}